function storePendingTabReturn(tabOriginalId, pendingKey) {
    try {
        const data = { tabId: tabOriginalId };
        globalThis.sessionStorage.setItem(pendingKey, JSON.stringify(data));
    }
    catch (_a) {
        // ignore storage errors
    }
}
function getAndClearPendingTabReturn(pendingKey) {
    try {
        const stored = globalThis.sessionStorage.getItem(pendingKey);
        globalThis.sessionStorage.removeItem(pendingKey);
        if (!stored)
            return null;
        return JSON.parse(stored);
    }
    catch (_a) {
        return null;
    }
}
function clearPendingTabReturn(pendingKey) {
    try {
        globalThis.sessionStorage.removeItem(pendingKey);
    }
    catch (_a) {
        // ignore storage errors
    }
}
function updateTabHash(tabId) {
    if (!tabId)
        return;
    const newHash = `#${tabId}`;
    if (globalThis.location.hash === newHash)
        return;
    globalThis.history.replaceState(globalThis.history.state, '', newHash);
}

export { clearPendingTabReturn, getAndClearPendingTabReturn, storePendingTabReturn, updateTabHash };
